import React from 'react';
import idleSvg from '../../assets/icons/side-nav.svg?raw';
import expandSvg from '../../assets/icons/side-nav-expand.svg?raw';
import collapseSvg from '../../assets/icons/side-nav-collapse.svg?raw';
import { svgInner } from './svgInner';

const VIEW_BOX = '0 -960 960 960';

/**
 * Gemini Luminous Symbols, drawn from the icon files rather than copies of
 * their path data — these three differ only in a small added chevron, so
 * keeping them by hand meant maintaining the same long path three times.
 */
const MARKUP = {
  side_nav: svgInner(idleSvg),
  side_nav_expand: svgInner(expandSvg),
  side_nav_collapse: svgInner(collapseSvg),
};

const SideNavIcon = ({ markup, size = 24, className = '', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox={VIEW_BOX}
    fill="none"
    className={className}
    aria-hidden="true"
    dangerouslySetInnerHTML={{ __html: markup }}
    {...props}
  />
);

/** Gemini Luminous Symbols: `side_nav` (idle). */
export const SideNav = (props) => (
  <SideNavIcon markup={MARKUP.side_nav} {...props} />
);

/** Gemini Luminous Symbols: `side_nav_expand` (collapsed hover). */
export const SideNavExpand = (props) => (
  <SideNavIcon markup={MARKUP.side_nav_expand} {...props} />
);

/** Gemini Luminous Symbols: `side_nav_collapse` (expanded hover). */
export const SideNavCollapse = (props) => (
  <SideNavIcon markup={MARKUP.side_nav_collapse} {...props} />
);
